// For gulp:
//jQuery(document).ready(function( $ ) {
// For WP:
(function($) {
//jQuery(function ($) {
    $('.sidebar-close, .overlay').on('click', function () {
        $('.sidebar').removeClass('active');
        $('.overlay').removeClass('active');
    });

    $('.sidebar-open').on('click', function () {
        $('.sidebar').addClass('active');
        $('.overlay').addClass('active');
    });

    $('.collapse')
        .on('shown.bs.collapse', function() {
            $(this)
            .parent()
            .find(".fa-chevron-down")
            .removeClass("fa-chevron-down")
            .addClass("fa-chevron-up");
        })
        .on('hidden.bs.collapse', function() {
            $(this)
            .parent()
            .find(".fa-chevron-up")
            .removeClass("fa-chevron-up")
            .addClass("fa-chevron-down");
    });

    $('.collapse-bonus-list span').click(function() {
        $(this).toggleClass("fa-chevron-down fa-chevron-up");
    });

    $('.search-button').on('click', function () {
        $('.search-input').removeClass("d-none").focus();
        $(this).addClass("d-none");
    });

    $( '.search-input' ).focusout(function() {
        $('.search-button').removeClass("d-none")
        $(this).addClass("d-none");
    });

    $('.review-tabs a').on('click', function () {
        $('.review-tabs .collapse').removeClass("show");
        $('.review-tabs a').removeClass("active");
        $(this).addClass("active");
    });

    const $window = $(window);

    if ($window.width() > 768) {
        $('.page-intro .card-body a.collapsed').addClass("d-none");
        $('.page-intro .card-body').removeClass("card-body");
        $('.page-intro').removeClass("shadow card");
    }

    const $fixedElement = $(".fixed-element")

    if ($window.width() > 768 && $fixedElement.length) {
        const offset            = $fixedElement.offset(),
        topPadding              = 95,
        documentHeight          = $(document).height();
        $window.scroll(function() {
            if ($window.scrollTop() > offset.top) {
                if ($(document).height() <= documentHeight) {
                    $fixedElement.stop().animate({
                        marginTop: $window.scrollTop() - offset.top + topPadding
                    });
                }
            } else {
                $fixedElement.stop().animate({
                    marginTop: 0
                });
            }
        });
    }

//});
})( jQuery );
//});